import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Typography
} from '@mui/material';
import { useTranslation } from 'react-i18next';

export function useConfirmacion() {

    const { t } = useTranslation();
  
    const [isOpen, setIsOpen] = useState(false);
    const [message, setMessage] = useState("");
    const [resolvePromise, setResolvePromise] = useState(null);

    const confirm = (msg) => {
        setMessage(msg);
        setIsOpen(true);
        return new Promise((resolve) => {
            setResolvePromise(() => resolve);
        });
    };

    const handleConfirm = () => {
        setIsOpen(false);
        resolvePromise(true);
    };

    const handleCancel = () => {
        setIsOpen(false);
        resolvePromise(false);
    };

    const ConfirmacionDialog = (

        <Dialog open={isOpen} onClose={handleCancel}>
            <DialogContent>
                <Typography>{message}</Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleCancel} variant="outlined">
                    {t('botones.cancelar')}
                </Button>
                <Button onClick={handleConfirm} className="boton1-menu" variant="contained">
                    {t('botones.aceptar')}
                </Button>
            </DialogActions>
        </Dialog>
    );

    return { confirm, ConfirmacionDialog };
}